import { useEffect } from "react";
import { BrowserRouter as Router, Route } from "react-router-dom";

import { appendAnalytics } from "utils/adobeAnalytics";

import { AppProvider } from "context/AppContext";
import Layout from "components/Layout/Layout";
import MyProfile from "pages/MyProfile";

const App = ({ user }) => {
    useEffect(() => {
        appendAnalytics();
    }, []);

    return (
        <AppProvider user={user}>
            <Router basename={process.env.PUBLIC_URL}>
                <Layout>
                    <Route path="/" component={MyProfile} />
                </Layout>
            </Router>
        </AppProvider>
    );
};

export default App; 

